import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const Wrapper = styled.div`
  width: 100%;

  .tab {
    margin-top: 2rem;
  }
`;

export const TabsHeader = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  width: 100%;
  position: relative;
`;

export const TabsList = styled.li`
  flex-basis: 100%;
  border-radius: 0.8rem;
  color: ${theme.colors.gray5};
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: relative;

  &.selected {
    font-weight: bold;
    color: ${theme.colors.primaryBlue};
  }

  .text {
    width: fit-content;
    font-size: max(0.9rem, 0.8vw);
  }


  ::after {
    position: absolute;
    display: none;
    content: "";
    border-top: .3rem solid ${theme.colors.primaryBlue};
    width: 20%;
    transform: translateY(45px);
  }

  &.selected::after {
    display: block;
  }
`;

export const LineTab = styled.div`
  position: absolute;
  height: 1px;
  background: ${theme.colors.gray3};
  width: 100%;
  top: 48px;
  left: 0;
`;
